import LocalStorage from '@/ultils/local-storage'
import router from '../router'
import axios from 'axios'

export function logout() {
    LocalStorage.removeItem('user_info')
    // ftth
    LocalStorage.removeItem('ftth_list_account')
    LocalStorage.removeItem('ftth_account')
    LocalStorage.removeItem('ftth_redirect_url')
    LocalStorage.removeItem('ftth_user_info')
    LocalStorage.removeItem('add_account_ftth')
    LocalStorage.removeItem('key_ftth_data')
}

export function isAuthenticated(path) {
    if (path.includes('/ftth') && path !== '/ftth/account-list') {
        if (LocalStorage.getItem('ftth_user_info') || LocalStorage.getItem('user_info')) {
            return true
        }else {
            logout()
            return false
        }
    } else if(LocalStorage.getItem('ftth_user_info') && path.includes('ucare')){
        return true
    } 

    if (!LocalStorage.getItem('user_info')) {
        logout()
        return false
    } else {
        return true
    }
}

export async function checkToSetAuthenticate(path, params) {
    if (params.accessToken && params.phone) {
        await addTokenLogin(params.accessToken, params.phone)
    }
    if (params.tokenLaoID) {
        const isPassLogin = await findPhone(params.tokenLaoID, params.language)
        if (isPassLogin) {
            return true;
        }

    }
    if (params.appCode) {
        LocalStorage.setItem('appCode', params.appCode)
    }
    if (params.token && params.sessionId && params.isdn) {
        let newParams = {
            originalUrl: path,
            token: params.token,
            sessionId: params.sessionId,
            isdn: params.isdn
        }
        LocalStorage.setItem('user_info', JSON.stringify(newParams))
        if (path.includes("/ftth")) {

            if (params.ftthAccount) {
                LocalStorage.setItem('ftth_account', params.ftthAccount)
            } else {
                newParams.originalUrl = "/ftth/login"
                LocalStorage.setItem('user_info', JSON.stringify(newParams))
                if (path !== '/ftth/login') {
                    router.push("/ftth/login")
                }
            }
        }
        return true
    } else {

        return false
    }
}

export function isLoginFtth() {
    let userInfo = JSON.parse(LocalStorage.getItem('user_info')) ?? {}
    let ftthUserInfo = JSON.parse(LocalStorage.getItem('ftth_user_info')) ?? {}
    if (Object.keys(userInfo).length === 0 && Object.keys(ftthUserInfo).length !== 0) {
        return true
    } else {
        return false
    }
}

export async function addTokenLogin(accessToken, phone, language) {
    let apiConfig = {
        method: 'post',
        url: '',
        data: null,
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json',
        contentType: 'application/json'
    }
    language = language ?? 'en'
    apiConfig['method'] = 'post'
    apiConfig['url'] = process.env.VUE_APP_ADD_TOKEN_LOGIN_API
    apiConfig['headers']['Authorization'] = `Bearer ${accessToken}`
    apiConfig['data'] = {
       username: phone,
       appCode: 'MyVTG',
       language: LocalStorage.getItem('lang')
    }



    await axios(apiConfig)
       .then(function (response) {
        console.log('addUniid req '+ JSON.stringify(apiConfig))
        // console.log('addUniid res '+ JSON.stringify(response))
        //   if (response.data.username == phone) {
            let userInfo = {
            token: response.data.token,
            isdn: response.data.username,
            sessionId: response.data.sessionId
            }
            LocalStorage.setItem('user_info', JSON.stringify(userInfo))
            LocalStorage.setItem('lang', language)
            console.log('return addTokenLogin')


           try {
               const fullUrl = window.location.href;
               const url = new URL(fullUrl);
               const hash = url.hash; // lấy phần sau dấu #
               const path = hash.replace('#', '').split('?')[0]; // loại bỏ dấu # và query nếu có
               console.log('path', path);

               router.push("/home?redirectUrl=" + path)
               return true
           } catch (error) {
               console.log('addTokenLoginError', error);
               router.push("/home")

           }
             return true
        //   } else {
            //  self.$store.dispatch('setNotification', { content: response.data.errorMessage })
        //      return false
        //   }
       })
       .catch(function () {
        //   self.$store.dispatch('setNotification', { content: self.$i18n.t('errors.system') })
          return false
       })
}

export async function findPhone(accessToken, language) {
    let apiConfig = {
        method: 'get',
        url: process.env.VUE_APP_FIND_PHONE_API,
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json',
        contentType: 'application/json'
    }
    apiConfig['headers']['Authorization'] = `Bearer ${accessToken}`
    apiConfig['headers']['x-api-key'] = process.env.VUE_APP_CLIENT_ID
    let phone

    // return addTokenLogin(accessToken, isdn, language); // bỏ dòng này khi upload lên server

    await axios(apiConfig)
       .then(function (response) {
        //   console.log('vao day: '+ JSON.stringify(response))
          if (response.data.statusCode == 'USER1200') {
             if (response.data && response.data.data && Array.isArray(response.data.data.phoneNumber)) {
                // Lấy mảng phoneNumber
                const phoneNumbers = response.data.data.phoneNumber;

                // Tìm số điện thoại có primary = true
                const primaryNumber = phoneNumbers.find(item => item.primary === true);

                // Nếu tìm thấy, dùng số đó, nếu không thì dùng số đầu tiên
                phone = primaryNumber ? primaryNumber.phoneNumber : phoneNumbers[0]?.phoneNumber || null;
             } else {
                // Trường hợp mảng không hợp lệ
                phone = null;
             }
            //  console.log('findphone '+ phone)
             return addTokenLogin(accessToken, phone, language)
          } else {
            return false
          }
       })
       .catch(function () {
            return false
       })
 }